import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IProject } from '../../interfaces/IProject';
import { map, pluck, share, tap } from 'rxjs/operators';
import { ProjectDataService } from '../../data-access/project-data.service';
import { IOptionalComponent, IProjectHeader } from '../../interfaces/IProjectHeader';
import { IProjectLocation } from '../../interfaces/IProjectLocation';
import { IProjectOperatingCompany } from '../../interfaces/IProjectOperatingCompany';
import { IProjectContract } from '../../interfaces/IProjectContract';
import { IProjectContractStage } from '../../interfaces/IProjectContractStage';
import { IAssetRelatedProject } from '../../interfaces/IAssetRelatedProject';
import { IProjectRelatedProject } from '../../interfaces/IProjectRelatedProject';
import { IProjectLink } from '../../interfaces/IProjectLink';
import { LocatorMediator } from 'src/app/assets/shared/locator-mediator';

// The ProjectDisplayContainer is a 'smart' component
// that is the root of the component hierachy for
// displaying a project page

@Component({
  selector: 'app-project-display',
  templateUrl: './project-display-container.component.html',
  styleUrls: ['../../project-display.styles.scss',
    './project-display-container.component.scss']
})
export class ProjectDisplayContainerComponent implements OnInit {
  @Input() public project$: Observable<IProject>;
  @Input() public projectId: number;

  projectHeader$: Observable<IProjectHeader>;
  projectLocations$: Observable<IProjectLocation[]>;
  operatingCompanies$: Observable<IProjectOperatingCompany[]>;
  projectContracts$: Observable<IProjectContract[]>;
  projectContractStages$: Observable<IProjectContractStage[]>;
  assetRelatedProjects$: Observable<IAssetRelatedProject[]>;
  relatedProjects$: Observable<IProjectRelatedProject[]>;
  projectLinks$: Observable<IProjectLink[]>;
  currentProject: {
    id: number,
    name: string,
    discriminator: string,
    lifecycle: string;
  };
  // discriminator: string;
  // lifecycle: string;
  optionalComponents$: Observable<IOptionalComponent[]>;
  projectFid$: Observable<IProject['fid']>;
  assetOperators$: any;
  assetContractors$: any;
  noLocation: boolean;

  logData: any;

  constructor(private projectDataService: ProjectDataService,
    private locatorMediator: LocatorMediator,) {
    this.currentProject = {
      id: 0, name: "",
      discriminator: "",
      lifecycle: ""
    };
  }

  ngOnInit() {
    // Map the data coming from the project endpoint
    // to only contain the values needed in the 
    // Project Header Component
    // The original hand-cranked mapping is replaced by
    // a map which more efficiently recasts the value
    const source$ = this.project$.pipe(share());

    this.projectHeader$ = source$.pipe(
      map(p => p as IProjectHeader),
      tap(p => {
        this.currentProject = {
          id: p.projectID,
          name: p.projectName,
          lifecycle: p.lifecycle,
          discriminator: p.discriminator
        };

        // The project/asset ID is converted to  a string for
        // compatability  with the existng logging endpoint
        // When we get rid of the old AngularJS project display,
        // this can be cleaned up
        if (p.discriminator == "Asset") {
          this.logData = { assetID: p.projectID.toString() };
        }
        else {
          this.logData = { projectID: p.projectID.toString() };
        }

        // this.discriminator = p.discriminator;
        // this.lifecycle = p.lifecycle;
      })
    );

    this.optionalComponents$ = this.projectHeader$.pipe(
      pluck("optionalComponents"),
    )

    this.projectFid$ = source$.pipe(
      pluck('fid')
    );

    // I could conceivable pluck the optional component data
    // out of the header - but I don;t believe all those details
    // should have been thee in the first place


    // Now the smart component can go and fetch
    // other data values
    this.projectLocations$ = this.projectDataService.getLocations(this.projectId);
    this.relatedProjects$ = this.projectDataService.getProjectRelatedProjects(this.projectId);
    this.projectLinks$ = this.projectDataService.getProjectLinks(this.projectId);
    this.assetRelatedProjects$ = this.projectDataService.getAssetRelatedProjects(this.projectId);
    this.operatingCompanies$ = this.projectDataService.getOperatingCompanies(this.projectId);
    this.projectContracts$ = this.projectDataService.getProjectContracts(this.projectId);
    this.projectContractStages$ = this.projectDataService.getProjectContractStages(this.projectId);

    this.assetOperators$ = this.projectDataService.getAssetOperator(this.projectId);
    this.assetContractors$ = this.projectDataService.getAssetContractors(this.projectId);

  }

  ngAfterViewInit() {

  }


  locateOnMap(locatorPosition: [number, number]) {
    // for the current asset:
    //   - determine the coordinates  
    this.noLocation = (locatorPosition == null);
    if (this.noLocation) return;

    // go to the map
    //   - probably need to  set up  a mediator
    //     to allow a message to be sent to the main search component

    // position the locator at the coordinates
    // make the locator layer visible}
    this.locatorMediator.publishLocatorPosition(locatorPosition);
  }

}




